var Shave = function() {
  var $ = require('jquery')
  require('shave');

  jQuery('.js-property-text').shave(65);
  
}
module.exports = Shave;